
export enum DockShipmentProgressCd {
	NOT_STRIPPED = 'NotStripped',
	STRIPPED = 'Stripped',
	TCONNED = 'TConned'}

